var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-layout",
        {
          staticStyle: { "padding-right": "10px" },
          attrs: { row: "", wrap: "" }
        },
        [
          _c("v-flex", { attrs: { xs12: "", sm6: "", md6: "" } }, [
            _c("div", [_vm._t("izquierda")], 2)
          ]),
          _c(
            "v-flex",
            {
              attrs: {
                xs12: "",
                sm6: "",
                md4: _vm.permisoAccion.visible,
                md6: !_vm.permisoAccion.visible
              }
            },
            [
              _c(
                "div",
                {
                  staticStyle: { "padding-top": "15px" },
                  attrs: { align: "right" }
                },
                [_vm._t("centro")],
                2
              )
            ]
          ),
          _c(
            "v-flex",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.permisoAccion.visible,
                  expression: "permisoAccion.visible"
                }
              ],
              staticStyle: { "padding-right": "0px" },
              attrs: { xs12: "", sm6: "", md2: "" }
            },
            [
              _c(
                "div",
                {
                  staticStyle: { "padding-top": "6px", "padding-right": "0px" },
                  attrs: { align: "right" }
                },
                [_vm._t("derecha")],
                2
              )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }